import { ApprovalStatus } from 'enums';
import { messages } from 'i18n';

const { approvalStatusLabels } = messages.submissionQueuePage;

export const approvalStatusConfig: Record<ApprovalStatus, { label: string; color: string }> = {
  [ApprovalStatus.Approved]: { label: approvalStatusLabels.approved, color: 'green.100' },
  [ApprovalStatus.Flagged]: { label: approvalStatusLabels.flagged, color: 'warning.light' },
  [ApprovalStatus.Rejected]: { label: approvalStatusLabels.rejected, color: 'error.light' },
};

export const getApprovalStatusLabel = (value: ApprovalStatus) => approvalStatusConfig[value].label;
